module.exports = __webpack_public_path__ + "img/secCtrlCenter_autoPolicy.190f5235.png";